module.exports = __webpack_public_path__ + "media/images/flags/4x3/glp-eff76739dbcda1fb0085b137ca36c91c.svg";